import {
    getPrimaryEnvironmentValue,
    normalizeEnvironmentValue,
    parseEnvironmentValues,
} from 'utils/multiEnvironment';

export const parseProductLinesEnvironmentValues = parseEnvironmentValues;

export const resolveProductLinesEnvironment = ({ idEnvironment, parentData }) => {
    return normalizeEnvironmentValue(
        idEnvironment ?? parentData?.idBranch ?? parentData?.idEnvironment,
    );
};

export const getProductLinesEnvironmentFilterValue = ({ idEnvironment, parentData }) => {
    return getPrimaryEnvironmentValue(
        resolveProductLinesEnvironment({ idEnvironment, parentData }),
    );
};
